// InterviewBlockUpdateView Constants
export const INTERVIEW_BLOCK_UPDATE_REQUEST = 'INTERVIEW_BLOCK_UPDATE_REQUEST';
export const INTERVIEW_BLOCK_UPDATE_SUCCESS = 'INTERVIEW_BLOCK_UPDATE_SUCCESS';
export const INTERVIEW_BLOCK_UPDATE_FAILURE = 'INTERVIEW_BLOCK_UPDATE_FAILURE';
export const INTERVIEW_BLOCK_UPDATE_RESET = 'INTERVIEW_BLOCK_UPDATE_RESET';

// InterviewCodingQuestionUpdateView Constants
export const INTERVIEW_CODING_QUESTION_UPDATE_REQUEST = 'INTERVIEW_CODING_QUESTION_UPDATE_REQUEST';
export const INTERVIEW_CODING_QUESTION_UPDATE_SUCCESS = 'INTERVIEW_CODING_QUESTION_UPDATE_SUCCESS';
export const INTERVIEW_CODING_QUESTION_UPDATE_FAILURE = 'INTERVIEW_CODING_QUESTION_UPDATE_FAILURE';
export const INTERVIEW_CODING_QUESTION_UPDATE_RESET = 'INTERVIEW_CODING_QUESTION_UPDATE_RESET';

// InterviewRoomMarkingView Constants
export const INTERVIEW_ROOM_MARKING_REQUEST = 'INTERVIEW_ROOM_MARKING_REQUEST';
export const INTERVIEW_ROOM_MARKING_SUCCESS = 'INTERVIEW_ROOM_MARKING_SUCCESS';
export const INTERVIEW_ROOM_MARKING_FAILURE = 'INTERVIEW_ROOM_MARKING_FAILURE';
export const INTERVIEW_ROOM_MARKING_RESET = 'INTERVIEW_ROOM_MARKING_RESET';

// GetAgentView Constants
export const GET_AGENT_REQUEST = 'GET_AGENT_REQUEST';
export const GET_AGENT_SUCCESS = 'GET_AGENT_SUCCESS';
export const GET_AGENT_FAILURE = 'GET_AGENT_FAILURE';
export const GET_AGENT_RESET = 'GET_AGENT_RESET';

// AskAgentView Constants
export const ASK_AGENT_REQUEST = 'ASK_AGENT_REQUEST';
export const ASK_AGENT_SUCCESS = 'ASK_AGENT_SUCCESS';
export const ASK_AGENT_FAILURE = 'ASK_AGENT_FAILURE';
export const ASK_AGENT_RESET = 'ASK_AGENT_RESET';





// CheckSessionExpiredView Constants
export const CHECK_SESSION_EXPIRED_REQUEST = 'CHECK_SESSION_EXPIRED_REQUEST';
export const CHECK_SESSION_EXPIRED_SUCCESS = 'CHECK_SESSION_EXPIRED_SUCCESS';
export const CHECK_SESSION_EXPIRED_FAILURE = 'CHECK_SESSION_EXPIRED_FAILURE';
export const CHECK_SESSION_EXPIRED_RESET = 'CHECK_SESSION_EXPIRED_RESET';

// RunCodeView Constants
export const RUN_CODE_REQUEST = 'RUN_CODE_REQUEST';
export const RUN_CODE_SUCCESS = 'RUN_CODE_SUCCESS';
export const RUN_CODE_FAILURE = 'RUN_CODE_FAILURE';
export const RUN_CODE_RESET = 'RUN_CODE_RESET';

// GetCodeView Constants
export const GET_CODE_REQUEST = 'GET_CODE_REQUEST';
export const GET_CODE_SUCCESS = 'GET_CODE_SUCCESS';
export const GET_CODE_FAILURE = 'GET_CODE_FAILURE';
export const GET_CODE_RESET = 'GET_CODE_RESET';




export const NOTIFICATION_LIST_REQUEST = 'NOTIFICATION_LIST_REQUEST';
export const NOTIFICATION_LIST_SUCCESS = 'NOTIFICATION_LIST_SUCCESS';
export const NOTIFICATION_LIST_FAIL = 'NOTIFICATION_LIST_FAIL';
export const NOTIFICATION_LIST_RESET = 'NOTIFICATION_LIST_RESET';
